export const users = [
  { id: "123", name: "Maria", activity: "development" },
  { id: "345", name: "Ioana", activity: "testing" },
];
